export const _size = /(:?=)(\d+?)/
